// src/components/page-renderer/SectionRenderer.jsx
import React from "react";
import ComponentRenderer from "./ComponentRenderer";

const layoutClass = {
  single: "grid grid-cols-1",
  two: "grid grid-cols-2 gap-10",
  three: "grid grid-cols-3 gap-10",
  grid: "grid grid-cols-2 md:grid-cols-4 gap-8",
};

export default function SectionRenderer({ section }) {
  return (
    <section className="px-6 py-16 max-w-7xl mx-auto">
      <div className={layoutClass[section.layout]}>
        {Object.values(section.columns).map((components, idx) => (
          <div key={idx} className="space-y-6">
            {components.map((c) => (
              <ComponentRenderer key={c.id} component={c} />
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
